import classNames from 'classnames';
import type { HTMLAttributes } from 'react';

import styles from './Tag.module.css';

type TagSize = 'sm' | 'md' | 'lg';
export type TagColorScheme = 'gray' | 'green' | 'red' | 'blue' | 'lightBlue';
export type TagVariant = 'subtle' | 'solid' | 'outline';

export interface TagProps extends HTMLAttributes<HTMLSpanElement> {
  size?: TagSize;
  colorScheme?: TagColorScheme;
  variant?: TagVariant;
  /** When provided, renders a close button that calls this on click. */
  onClose?: () => void;
}

/** An inline-flex pill, optionally with a close button. */
export const Tag = ({
  size = 'md',
  colorScheme = 'gray',
  variant = 'subtle',
  onClose,
  className,
  children,
  ...rest
}: TagProps) => (
  <span
    className={classNames(
      styles.tag,
      styles[size],
      styles[colorScheme],
      styles[variant],
      className
    )}
    {...rest}
  >
    <span className={styles.label}>{children}</span>
    {onClose ? (
      <button
        type="button"
        aria-label="Remove"
        className={styles.close}
        onClick={onClose}
      >
        <svg
          viewBox="0 0 12 12"
          width="12"
          height="12"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M4 4 8 8M8 4 4 8"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </button>
    ) : null}
  </span>
);
